// Tokens visuais (tema claro) — alinhados com o acento único usado em toda a
// app (C.blue no App.js / Sidebar), em vez de um índigo à parte.
export const T = {
  bg: "#F4F7F9",
  surface: "#ffffff",
  border: "#E4E7EC",
  borderSoft: "#EAECF0",
  text: "#101828",
  textMid: "#475467",
  textLight: "#98A2B3",

  blue: "#0F766E",
  blueBg: "#E6F8F5",
  blueBorder: "#B9E9E1",

  green: "#157347",
  greenBg: "#EDF7F1",
  greenBorder: "#A3D9B7",

  amber: "#92640C",
  amberBg: "#FEF8EC",
  amberBorder: "#F5DFA0",

  red: "#C0302A",
  redBg: "#FEF0F0",
  redBorder: "#F5C0BF",
} as const;
